import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { ApiCallStatus } from "../../utils/constants";
import Trade from "../../components/Trade";

const TradePage = ({ genericDataLoaded }) => {
  const pageIsLoading = genericDataLoaded === false;

  return (
    <>
      <Trade />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={pageIsLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default TradePage;
